import gql from 'graphql-tag';

export const UPSERT_DEPARTMENTS = gql`
  mutation UpsertDepartments($input: UpsertDepartmentsInput!) {
    bpf {
      result: upsertDepartments(input: $input) {
        error
        success
        list {
          id
        }
      }
    }
  }
`;
